import { strings } from "../../localization";
import { StepInformationType } from "./models";

export enum MattressSizeOptions {
    TWIN = "twin",
    TWIN_XL = "twin long",
    FULL = "full",
    QUEEN = "queen",
    KING = "king",
    CAL_KING = "ca king",
    SPLIT_KING = "split king",
    CAL_SPLIT_KING = "split ca king",
}
enum SleepPositionOptions {
    BACK = "back",
    SIDE = "side",
    STOMACH = "stomach",
}
enum HeightOptions {
    HEIGHT_5FT = "lt_5ft",
    HEIGHT_5_6FT = "eq_5_6ft",
    HEIGHT_6FT = "gt_6ft",
}
enum WeightOptions {
    WEIGHT_150LBS = "lt_150lbs",
    WEIGHT_150_200LBS = "eq_150_200lbs",
    WEIGHT_250LBS = "gt_250lbs",
}
export enum CoolnessOptions {
    NEVER = "never",
    SOMETIMES = "sometimes",
    ALWAYS = "always",
}
enum PriceLevelOptions {
    PRACTICAL = "practical",
    BALANCED = "balanced",
    LIMITLESS = "limitless",
}
export enum Step {
    SIZE = "SIZE",
    SLEEP = "SLEEP",
    HEIGHT = "HEIGHT",
    WEIGHT = "WEIGHT",
    COOLING = "COOLING",
    BUDGET = "BUDGET",
    RESULTS = "RESULTS",
}
export enum FetchResultsStatusType {
    IDLE = "idle",
    LOADING = "loading",
    SUCCESS = "success",
    ERROR = "error",
}
export const stepOrder = [
    Step.SIZE,
    Step.SLEEP,
    Step.HEIGHT,
    Step.WEIGHT,
    Step.COOLING,
    Step.BUDGET,
    Step.RESULTS,
] as const;

export const stepInformation: StepInformationType = {
    [Step.SLEEP]: {
        key: "selectedSleepPosition",
        heading: strings.get("MATTRESS_SELECTOR_SLEEP_HEADING"),
        description: strings.get("MATTRESS_SELECTOR_SLEEP_DESCRIPTION") || "",
        data: [
            {
                level: 1,
                value: SleepPositionOptions.BACK,
                valid: false,
                label: "Back",
                icon: "back",
            },
            {
                level: 2,
                value: SleepPositionOptions.SIDE,
                valid: false,
                label: "Side",
                icon: "side",
            },
            {
                level: 3,
                value: SleepPositionOptions.STOMACH,
                valid: true,
                label: "Stomach",
                icon: "stomach",
            },
        ],
    },
    [Step.HEIGHT]: {
        key: "selectedHeight",
        heading: strings.get("MATTRESS_SELECTOR_HEIGHT_HEADING"),
        description: strings.get("MATTRESS_SELECTOR_HEIGHT_DESCRIPTION") || "",
        data: [
            {
                level: 1,
                value: HeightOptions.HEIGHT_5FT,
                label: "- 5FT",
                icon: "height-short",
            },
            {
                level: 2,
                value: HeightOptions.HEIGHT_5_6FT,
                label: "5-6 FT",
                icon: "height-middle",
            },
            {
                level: 3,
                value: HeightOptions.HEIGHT_6FT,
                label: "6FT +",
                icon: "height-tall",
            },
        ],
    },
    [Step.WEIGHT]: {
        key: "selectedWeight",
        heading: strings.get("MATTRESS_SELECTOR_WEIGHT_HEADING"),
        description: strings.get("MATTRESS_SELECTOR_WEIGHT_DESCRIPTION") || "",
        data: [
            {
                level: 1,
                value: WeightOptions.WEIGHT_150LBS,
                label: "- 150 lbs",
                icon: "weight-light",
            },
            {
                level: 2,
                value: WeightOptions.WEIGHT_150_200LBS,
                label: "150-250 lbs",
                icon: "weight-middle",
            },
            {
                level: 3,
                value: WeightOptions.WEIGHT_250LBS,
                label: "250 lbs +",
                icon: "weight-heavy",
            },
        ],
    },
    [Step.COOLING]: {
        key: "selectedCoolness",
        heading: strings.get("MATTRESS_SELECTOR_COOL_HEADING"),
        data: [
            {
                level: 1,
                value: CoolnessOptions.NEVER,
                valid: false,
                label: "Never",
                icon: "cooling-no-heat",
            },
            {
                level: 2,
                value: CoolnessOptions.SOMETIMES,
                valid: false,
                label: "Sometimes",
                icon: "cooling-mild",
            },
            {
                level: 3,
                value: CoolnessOptions.ALWAYS,
                valid: true,
                label: "Always",
                icon: "cooling-hot",
            },
        ],
        description: strings.get("MATTRESS_SELECTOR_COOL_DESCRIPTION") || "",
    },
    [Step.BUDGET]: {
        key: "selectedBudget",
        heading: strings.get("MATTRESS_SELECTOR_BUDGET_HEADING"),
        data: [
            {
                level: 1,
                value: PriceLevelOptions.PRACTICAL,
                icon: "budget-piggy",
                label: "Practical",
            },
            {
                level: 2,
                value: PriceLevelOptions.BALANCED,
                icon: "budget-balance",
                label: "Balanced",
            },
            {
                level: 3,
                value: PriceLevelOptions.LIMITLESS,
                icon: "budget-forever",
                label: "Limitless",
            },
        ],
        description: strings.get("MATTRESS_SELECTOR_BUDGET_DESCRIPTION") || "",
    },
};

export const SizeData = [
    {
        value: MattressSizeOptions.TWIN,
        label: "Twin",
    },
    {
        value: MattressSizeOptions.TWIN_XL,
        label: "Twin XL",
    },
    {
        value: MattressSizeOptions.FULL,
        label: "Full",
    },
    {
        value: MattressSizeOptions.QUEEN,
        label: "Queen",
    },
    {
        value: MattressSizeOptions.KING,
        label: "King",
    },
    {
        value: MattressSizeOptions.CAL_KING,
        label: "California King",
    },
    {
        value: MattressSizeOptions.SPLIT_KING,
        label: "Split King",
    },
    {
        value: MattressSizeOptions.CAL_SPLIT_KING,
        label: "Split California King",
    },
];
